export default "__VITE_ASSET__CjX9OGbQ__"